<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false" on-slide-changed="slideChange($index)">
      <slide>
        <div class="padding">
          <div>
            <p>I woke in the night with my sheets soaked in sweat, the taste of salt in my mouth and I was afraid. My mind raced and I listened for a sound I expected to hear, that I always hear. </p>
            <p> &nbsp;</p>
            <p>I could not hear him breathing, and it frightened me. I heard the rain outside the window, hammering on the glass and I could hear someone crying from across the hall outside the apartment, crying in the room the girl with bird arms lived in. </p>
            <p> &nbsp;</p>
            <p>Then he coughed and I let out the breath I did not know I had been holding since I woke. It rushed out of me like a scream. </p>
            <p>He coughed, and coughed some more, and then was suddenly silent. I wiped my face with the flannel by my side of the bed and threw back the covers. The room was dark and I walked across the floor and into the hallway. His room was unlit too, and I snapped the light switch on. </p>
            <p></p>
            <p>There was nothing in the room. Nothing but a wooden crate and a pile of books.
            I screamed.</p>
            <p> &nbsp;</p>
            <p>but then I blinked, and the heaped clothing became a body and the books a head and the crates a bed. And my child is there sleeping.
            My child was sleeping but for a moment had gone.</p>
            <p> &nbsp;</p>
            <p>He came back though, he returned to me.</p>
            <p> &nbsp;</p>
            <p>Did he go to you, reach out to you?</p>
            <p> &nbsp;</p>
            <p>would you even recognise him?</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </div>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <div>
            <span class="arch">
              <p>I look out across the city and see the footsteps I left behind as I walked to this spot. I see a moment that is coming fast, that is advancing like a storm from the sea, churning the sky and the harbour from horizon to here. The city in which I stand, which is an old city and built from stone and brick and memory, it can't hold, I see it now, it is too fluid, and it will wash away.</p>
              <p> &nbsp;</p>
              <p>When I close my eyes I see a coming storm.</p>
              <p> &nbsp;</p>
              <p>I see another architecture impact upon this one, buildings crash into each other and stone rains down into the street. A dustcloud gathers from the river, an impossible moment that gathers everything into it, the people below, their cries and their tears.</p>
              <p> &nbsp;</p>
              <p>This is a dust made of memory and it leaves nothing behind.</p>
              <p>Then silence falls. </p>
              <p> &nbsp;</p>
              <p>The city that is left is iron clad and garlanded in rust and dead roses. Creeping skyward, framing the stars and the firestorm behind the walls.
              Every moment the storm starts again, a flare between the flames and the water, the heat licking at the plustens, the concrete and the wood, burning something vital away.
              Paint and oil, wax and linen.</p>
              <p>The streets are cleared, and only the remains of the city are visible. </p>
              <p>There were gardens here once. Flowers climbed the walls and grew around the railings.</p>
              <p>In the future I see there is nothing but burning and an echo, clearing the ground. </p>
              <p>Behind me, I hear a voice, a child's voice asking a question. Imploring an answer.  </p>
              <p></p>
              <p></p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p>I snap back, </p>
              <p>I no longer see what will be, just what is. </p>
              <p>There is no child, but there was. </p>
              <p>There were two cities and there will be one. </p>
              <p> &nbsp;</p>
              <p>I know which one I saw fall. </p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
            </span>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'Empty'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
